// ========================================================
// VECTARY AR LINKS — iOS/Safari FIX
// Rewrite Vectary viewer-ar links to direct USDZ files so
// iOS AR Quick Look launches correctly.
// ========================================================
document.addEventListener("DOMContentLoaded", () => {
	const isIOS =
		/iPhone|iPad|iPod/i.test(navigator.userAgent) ||
		(navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

	if (!isIOS) return;

	document
		.querySelectorAll('a[href*="vectary.com/viewer-ar/v1/"]')
		.forEach((link) => {
			const url = new URL(link.href);
			const model = url.searchParams.get("model");

			if (!model) return;

			const scaling = url.searchParams.get("allowScaling") ?? "1";

			link.href =
				`https://www.vectary.com/viewer/data/${model}/usdz/${model}.usdz` +
				`#allowsContentScaling=${scaling}`;

			link.removeAttribute("target");
		});
});
